"use client";

import { useEffect } from "react";
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "@/firebase/firebase-init";
import { useToken } from "@/lib/use-token";
import { registerFcmToken } from "@/services/notification.service";

export function useFcmToken() {
  const { hasToken } = useToken();
  const loggedIn = hasToken();

  useEffect(() => {
    if (!messaging || !loggedIn) return;

    const requestPermission = async () => {
      const permission = await Notification.requestPermission();

      if (permission !== "granted") return;

      const token = await getToken(messaging, {
        vapidKey:
          "BFq77iOiI6vbyzPok9q2ZbkRFImFVONdZVSJ36sCG69F4QC7y7gdJUVmIII1HcpN-XO1SyWQVWGkKioVWmBgLTI",
      });

      if (!token) return;

      await registerFcmToken(token);
    };

    requestPermission();

    onMessage(messaging, (payload) => {
      new Notification(payload.notification?.title ?? "", {
        body: payload.notification?.body,
      });
    });
  }, [loggedIn]);
}
